import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { AddMemberRequest } from '../../models/ss-api/requests/add.member.request';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { Router } from '@angular/router';


export interface IAddMemberDialogModel {
    title: string;
    subTitle: string;
    message: string;
}


@Component({
    selector: 'add-member-dialog',
    styleUrls: ['./add.member.dialog.css'],
    templateUrl: './add.member.dialog.html'
})
export class AddMemberDialog extends DialogComponent<IAddMemberDialogModel, IBaseResponse<string>> implements IAddMemberDialogModel, OnInit {
    title: string;
    subTitle: string;
    message: string;

    request = new AddMemberRequest();

    NewMemberForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }


    ngOnInit() {
        this.NewMemberForm = new FormGroup({
            'FirstName': new FormControl('', [Validators.required]),
            'LastName': new FormControl('', [Validators.required]),
            'Email': new FormControl('', [Validators.required, Validators.email]),
            'Password': new FormControl('', [Validators.required, Validators.minLength(5)]),
            'Company': new FormControl('', [Validators.required]),
            'Address1': new FormControl('', [Validators.required, Validators.minLength(5)]),
            'City': new FormControl('', [Validators.required, Validators.minLength(3)]),
            'State': new FormControl('', [Validators.required, Validators.minLength(2)]),
            'ZipCode': new FormControl('', [Validators.required, Validators.minLength(3)]),
            'Country': new FormControl('US', [Validators.required]),
            'Phone1': new FormControl('', [Validators.required, Validators.minLength(14)])
        })

        this.request.Country = 'US';
        this.request.Phone1 = '';

        this.NewMemberForm.controls.Phone1.valueChanges.subscribe((value) => {
            const correctValue = this.getPhoneInputValue(value);
            if (value !== correctValue) {
              this.NewMemberForm.controls.Phone1.setValue(correctValue, {
                emitEvent: false // Prevent triggering the subscription again
              });
            }
          });
    }

    public getPhoneInputValue( v : string ) : string {
	

        // trim '-' dashes
        v = v.replace(/-/g,'');
    
        v = v.replace(/[^\d]/g, "");
        
        // trim string to 15 characters
        if( v.length > 10) {
            if (v.length > 15) {
                v = v.substr(0, 15);
            }
            return '   +' + v;
        }
        
    
        // new array to hold sections of the cd key
        let numbers = [];
    
        // create set of characters from first 5 characters
        numbers.push(v.substr(0,3));
        
        // try for next 5
        if(v.substr(3,3)!=="")
            numbers.push(v.substr(3,3));
        
        // and last set of 5
        if(v.substr(6,10)!="")
            numbers.push(v.substr(6,4));
        
        if(v.substr(10,15)!="")
            numbers.push(v.substr(10,5));
    
        // add '-' dashes back to formated string
        let newValue = numbers[0];
        
        //if( newValue.length == 3 ) {
            
        //}
    
        if( numbers.length > 1 ) {
            newValue = '(' + newValue + ') ';
            newValue += numbers[1];
        }
            
    
        if (numbers.length > 2 )
            newValue += '-' + numbers[2];
    
        // if (numbers.length > 3 )
        // 	newValue += '-' + numbers[3];
    
        return newValue;
    }

    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        await this.sweetAlertService.swal(
            {
                title: 'Add Member?',
                text: 'Are you sure you want to add this new Member?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    //Clean the phone of punctuation before submitting
                    this.request.Phone1 = this.request.Phone1.replace(/[^\d]/g, "");
                    return this.api.MemberAdd(this.request).toPromise();  /// <------ !!! FIX THIS !!!
                }
            })
            .then(async (response: IBaseResponse<string>) => {

                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            return;
                        }, (dismiss) => {
                            return;
                        }); // keep this line to prevent promise error;


                    return;
                }

                // ok

                this.sweetAlertService.swal(
                    {
                        title: 'Member Added',
                        text: 'Shout \'HOORAY!\'',
                        type: 'success',
                        timer: 1500,
                        showCancelButton: false,
                        showConfirmButton: false,
                    })

                    .then((response: any) => {
                        this.result = response;
                        this.close();

                        return;

                    }, (dismiss) => {
                        this.result = response;
                        this.close();
                        return;
                    }); // keep this line to prevent promise error;

            }, (dismiss) => {

                this.result = null;
                this.close();

            }); // keep this line to prevent promise error;

    }

}